import { Component, OnDestroy, OnInit } from '@angular/core';
import { JhiAlert, JhiAlertService } from '../core-utils';

@Component({
    selector: 'jhi-alert',
    template: `
        <ngb-toast
                *ngFor="let toast of alerts"
                [class]="toast.classname"
                [autohide]="false"
                [delay]="toast.timeout || 5000"
                (hidden)="alertService.closeAlert(toast.id, alerts)">
            <div class="row">
                @if (toast.template) {
                    <ng-container [ngTemplateOutlet]="toast.template"></ng-container>
                } @else {
                    <div class="col custom-scroll-style" style="overflow-y: auto; max-height: 500px;">
                        <span [innerHTML]="toast.msg"></span>
                    </div>
                    <div class="col-auto">
                        <button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close" (click)="alertService.closeAlert(toast.id, alerts)"></button>
                    </div>
                }
            </div>
        </ngb-toast>
    `,
    styles: [`
        .alert-bg-success {
            color: #1c561c !important;
            background-color: #d7edd7;
            border-color: #c7e6c7;
            box-shadow: unset !important;
        }

        .alert-bg-danger {
            color: #6f1d1b !important;;
            background-color: #f7d7d6;
            border-color: #f4c7c6;
            box-shadow: unset !important;
        }

        .alert-bg-warning {
            color: #774102 !important;;
            background-color: #fae5cd;
            border-color: #f8dbb8;
            box-shadow: unset !important;
        }


    `],
    host: { class: 'toast-container position-fixed top-0 end-0 p-3', style: 'z-index: 10000000' },
})
export class JhiAlertComponent implements OnInit, OnDestroy {
    alerts: JhiAlert[];

    constructor(public alertService: JhiAlertService) { }

    ngOnInit() {
        this.alerts = this.alertService.get();
    }

    ngOnDestroy() {
        this.alerts = [];
    }

    protected readonly alert = alert;
}
